<template>
    <div :class="skeleton">
        <div class="p-2 loading w-1/2 rounded-full bg-gray-850"></div>
        <div class="p-2 loading w-[60%] rounded-full bg-gray-850"></div>
        <div class="p-2 loading w-[80%] rounded-full bg-gray-850"></div>
        <div class="p-6 loading w-full rounded-full bg-gray-850"></div>
        <div class="flex space-x-2">
            <div class="p-6 py-10 loading w-full rounded-lg bg-gray-850"></div>
            <div class="p-6 py-10 loading w-full rounded-lg bg-gray-850"></div>
        </div>
        <div class="h-1 w-full rounded-full bg-gray-850"></div>
        <div class="p-2 loading w-[90%] rounded-full bg-gray-850"></div>
        <div class="p-2 loading w-[90%] rounded-full bg-gray-850"></div>
        <div class="p-2 loading w-[90%] rounded-full bg-gray-850"></div>
        <div class="p-2 loading w-[90%] rounded-full bg-gray-850"></div>
    </div>
</template>
<script lang="ts" setup>
import { cva } from "class-variance-authority";

interface Props {
    size: "sm" | "md" | "lg" | "xl";
}
const skeleton = computed(() => {
    return cva(" loading py-12 px-4 flex flex-col lg:space-y-6 space-y-4   rounded-2xl bg-gray-900 w-full  ", {
        variants: {
            size: {
                sm: "h-[500px]",
                lg: "h-[611px]",
            },
        },
        defaultVariants: { size: "lg" },
    })({
        size: props.size,
    });
});

const props = defineProps<Props>();
</script>
